import React from 'react';

const CreativeBottombar = props => (
  <svg width="1em" height="1em" viewBox="0 0 36 26" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#none" d="M-378-12007h1600V183H-378z" />
      <g>
        <rect
          width={35}
          height={25}
          x={0.5}
          y={0.5}
          fill="#FFF"
          stroke="currentColor"
          rx={2}
        />
        <rect
          width={30}
          height={8}
          x={3}
          y={15}
          fill="currentColor"
          fillOpacity={0.3}
          rx={1}
        />
      </g>
    </g>
  </svg>
);

export default CreativeBottombar;
